import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";

const Row = ({ bid, onRemove, onUpdate}) => {
    const country = bid.country === 'D' ? 'DEFAULT' : bid.country;

    return (<tr>
        <td style={{ textAlign: 'left' }}>{country}</td>
        <td>{bid.bid}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="info" onClick={() => onUpdate(bid)}>Update</Button>
                <Button bsStyle="danger" onClick={() => onRemove(bid.country)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkBids/components/Table/components/Row/index.js